// extracted by mini-css-extract-plugin
module.exports = {"small":"NftHeader_small__GHm0k","appear":"NftHeader_appear__r4seS"};